import { UserRole } from '../../enums/userEnums';

/** Add clauses (subscription plan, status) as optional fields; all present clauses must pass. */
export interface AccessRequirements {
  allowedRoles?: UserRole[];
}

export interface AccessSubject {
  role?: UserRole;
}

/** Gates UI only — the backend stays the authority. Denies on a missing or unknown role. */
export const checkAccess = (subject: AccessSubject, requirements: AccessRequirements): boolean => {
  const { allowedRoles } = requirements;
  if (allowedRoles && (!subject.role || !allowedRoles.includes(subject.role))) return false;
  return true;
};
